// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1kuzn","vLegacy":"SelectSecondary_vLegacy__3DXro","error":"SelectSecondary_error__3xN_Q","disabled":"SelectSecondary_disabled__3FwXz"};